import styled from 'styled-components';

const HiddenButton = styled.button`
  display: none;
`;

HiddenButton.displayName = 'HiddenButton';

export default HiddenButton;
